import { Box, Stack, Typography } from "@mui/material";
import type { PropsWithChildren, ReactNode } from "react";

export interface PageLayoutProps extends PropsWithChildren {
  title: ReactNode;
  titleAdornment?: ReactNode;
  actions?: ReactNode;
  maxWidth?: number;
}

export const PageLayout = ({ title, titleAdornment, actions, maxWidth, children }: PageLayoutProps) => (
  <Stack spacing={2} sx={{ width: "100%", maxWidth, mx: "auto" }}>
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 2,
        mb: actions ? 1 : 0,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
        <Typography component="h1" variant="h4" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        {titleAdornment}
      </Box>
      {actions ? <Box sx={{ width: { xs: "100%", sm: "auto" }, flexShrink: 0 }}>{actions}</Box> : null}
    </Box>
    {children}
  </Stack>
);
